import React, {Component} from 'react'
import {Footer} from '@sabre/spark-react'
import 'sabre-spark/dist/css/spark.light.css'


class SplashTemplate extends Component {
    render() {
        return (
            <div className="spark-content--sticky-footer">
                <div className="spark-content__wrapper--sticky-footer">
                    <article className="spark-splash-screen spark-main--sticky-footer">
                        <section className="spark-splash-screen__content">
                            <div className="spark-splash-screen__center">
                                {this.props.children}
                            </div>
                        </section>
                    </article>
                    <Footer/>
                </div>
            </div>
        )
    }
}

export default SplashTemplate



// WEBPACK FOOTER //
// ./src/shared/components/SplashTemplate.js